const KEY = {
  APIKEY_BACKEND: '765hjSST70fdgfgdfgdfea118'
}
export { KEY }
